var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-detail"},[(_vm.product && _vm.product.spuId)?_c('NewProduct'):_c('empty',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstFetch),expression:"!firstFetch"}],attrs:{"text":"没有找到该商品"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }